import { render, staticRenderFns } from "./DonutChart.vue?vue&type=template&id=6767c2ec&scoped=true&"
import script from "./DonutChart.vue?vue&type=script&lang=ts&"
export * from "./DonutChart.vue?vue&type=script&lang=ts&"
import style0 from "./DonutChart.vue?vue&type=style&index=0&id=6767c2ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6767c2ec",
  null
  
)

export default component.exports